import { createAsyncThunk } from "@reduxjs/toolkit";
import talentApi from "api/talentApi";
import { formatQueryParams } from "helpers/format";

export const getTalents = createAsyncThunk("Talents", async (params: any = {}) => {
  try {
    const response = await talentApi.talentList(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const getTalentDetail = async (id: string | number) => {
  try {
    const response = await talentApi.getTalentDetail(id);
    return response;
  } catch (error) {
    return error;
  }
};


export const createTalent = async (data: any = {}) => {
  try {
    const response = await talentApi.postTalent(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateTalent = async (id: string | number, data: any = {}) => {
  try {
    const response = await talentApi.putTalent(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
